import React, { useEffect, useState } from 'react';
import '../styles/Browse.css';
import Tmdb from '../Tmdb.js';
import MovieRow from '../components/MovieRow';
import FeaturedMovie from '../components/FeaturedMovie';
import Header from '../components/Header';
import MovieSkeleton from '../components/MovieRow/MovieSkeleton.jsx';
import FeaturedMovieSkeleton from '../components/FeaturedMovie/FeaturedMovieSkeleton.jsx';

const Browse = () => {
  const [movieList, setMovieList] = useState([]);
  const [featuredData, setFeaturedData] = useState(null);
  const [blackHeader, setBlackHeader] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [numberMovies, setNumberMovies] = useState(null);

  useEffect(()=>{
    const loadAll = async () => {
      let list = await Tmdb.getHomeList();
      setMovieList(list);

      let originals = list.filter(e => e.slug === 'originals');
      let randomChose = Math.floor(Math.random() * (originals[0].items.results.length - 1));
      let theChosenOne = originals[0].items.results[randomChose];
      let chosenInfo = await Tmdb.getMovieInfo(theChosenOne.id, 'tv');
      setFeaturedData(chosenInfo);
      setIsLoading(false);
    }
    loadAll();
  }, []);

  useEffect(() => {
    const scrollListener = () => {
      if(window.scrollY > 10) {
        setBlackHeader(true);
      } else {
        setBlackHeader(false);
      }
    }
    setNumberMovies(Math.floor((window.innerWidth - 30)/200));
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    }
  }, []);

  return (
    <div className="browse">

      <Header black={blackHeader} />

      {featuredData && <FeaturedMovie item={featuredData} />}

      {isLoading && <FeaturedMovieSkeleton />}
      {isLoading && <MovieSkeleton cards={numberMovies} />}

      <section className='lists'>
        {movieList.map((item, key)=>(
          <MovieRow key={key} title={item.title} items={item.items} />
        ))}
      </section>

      <footer>
        Direitos de imagem para <strong>Netflix</strong><br/>
        Dados pegos no site <strong><a href='https://www.themoviedb.org/' target='_blank' rel='noopener noreferrer'>themoviedb.org</a></strong>
      </footer>
    </div>
  );
}

export default Browse;
